import { render, staticRenderFns } from "./SampleReceivedStatusBody.vue?vue&type=template&id=47b99f2d&"
import script from "./SampleReceivedStatusBody.vue?vue&type=script&lang=js&"
export * from "./SampleReceivedStatusBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports